import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * Androidのソフトウェアキーボード出現時に要素が隠れないようにする
 */
export default class EFOcats_event_androidkeybord extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    const ua = window.navigator.userAgent.toLowerCase();

    // androidだけ
    if (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1) {
      this.winHeight = 0;

      // キーボードの出現に応じて画面をリサイズ
      this.resize();

      // 入力欄でEnterしたらtabindex遷移する
      this.keydown_enter();
    }
  }

  /**
   * 入力欄でEnterしたらtabindex遷移する
   */
  keydown_enter() {
    this.$('input').on('keydown', event => {
      if (event.which === 13) {
        const element = event.currentTarget;
        if ($(element).attr('tabindex') && $(element).attr('tabindex') > 0) {
          const nextInput = Number($(element).attr('tabindex')) + 1;
          if ($(element).parents('.qa').find(`[tabindex="${nextInput}"]`).length > 0) {
            const focusItem = $(element).parents('.qa').find(`[tabindex="${nextInput}"]`).first();

            if (!focusItem.attr('readonly') && !['checkbox', 'radio', undefined].includes(focusItem.attr('type'))) {
              focusItem.trigger('focus');
              this.nextMove($(element), focusItem);
            } else {
              $(element).trigger('blur');
            }
          } else {
            $(element).trigger('blur');
          }
        } else {
          $(element).trigger('blur');
        }
      }
    });
  }

  /**
   * メニューバーなどの微妙な高さ変更の調整
   */
  resize() {
    const iframewin = efocats.making.iframe.contentWindow;

    $(iframewin).on('resize', event => {
      const focusItem = this.$(':focus');

      if (focusItem.prop('tagName') !== 'INPUT' || !['text', 'tel', 'email', 'password'].includes(focusItem.attr('type'))) {
        return;
      }

      this.move(focusItem);
      this.winHeight = $(iframewin).height();
    });

    $(window).on('resize', event => {
      const innnerHeight = window.innerHeight;
      const screenHtight = window.parent.screen.height;

      if (innnerHeight <= (screenHtight / 3) * 2) return;

      setTimeout(() => {
        this.$('.cat-wrapper').height(window.innerHeight);
      }, 10);
    });
  }

  /**
   * 遷移
   * @param {*}} focusItem
   */
  move(focusItem) {
    // キーボード出現前とのウィンドウサイズ差分を取得
    const iframewin = efocats.making.iframe.contentWindow;
    const diff = this.winHeight - $(iframewin).height();

    // 現在のスクロール位置を取得
    const border = focusItem.parents('.cat-section--border');
    const top = border.scrollTop();

    // キーボードが出現した分だけスクロールを戻す
    border.scrollTop(top + diff);
  }

  /**
   * 次の要素へ移動した時の調整
   * @param {*} currentItem
   * @param {*} focusItem
   */
  nextMove(currentItem, focusItem) {
    // 現在の要素と次の要素の位置の差分を取得
    const currentTop = currentItem.offset().top;
    const focusTop = focusItem.offset().top;
    const diff = focusTop - currentTop;

    // 現在のスクロール位置を取得
    const border = focusItem.parents('.cat-section--border');
    const top = border.scrollTop();

    // 差分の分だけ移動する
    border.scrollTop(top + diff);
  }
}
